import React from 'react';
import { useCart } from '../contexts/CartContext';
import './CartIndicator.css';

function CartIndicator({ inline = false }) {
  const { cartCount } = useCart();
  
  if (inline) {
    // Return a simpler version for inline usage in navbar
    return (
      <span className="cart-indicator-inline">
        <span className="cart-icon">🛒</span>
        {cartCount > 0 && (
          <span className="cart-count-inline">{cartCount}</span>
        )}
      </span>
    );
  }
  
  // Original standalone version
  return (
    <div className="cart-indicator">
      <div className="cart-icon">🛒</div>
      {cartCount > 0 && (
        <div className="cart-count">{cartCount}</div>
      )}
    </div>
  );
}

export default CartIndicator;